module.exports = __webpack_public_path__ + "static/media/enterprise.93a32149.png";